import { USE_MOCK_API } from './httpClient'
import * as mock from './places.mock'
import * as http from './places.http'
const impl = USE_MOCK_API ? mock : http
export const listPlaces = impl.listPlaces
export const addPlace = impl.addPlace
export const updatePlace = impl.updatePlace
export const deletePlace = impl.deletePlace
